/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Mode_ByokInputs */



/**
* | output |
* | --- |
* | "Bring your own key" |
*
* @param {Integrations_Mode_ByokInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_mode_byok = /** @type {((inputs?: Integrations_Mode_ByokInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Mode_ByokInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigener API-Schlüssel")
	return /** @type {LocalizedString} */ ("Bring your own key")
});